<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")
    v-card
      v-card-title.pa-2(style="background-color: var(--v-basic600T16)")
        v-row(no-gutters)
          v-col.shrink.mr-3
            v-btn.mr-n2(text icon @click="showModal = !showModal" height)
              eva-icon.ma-1(name="close" :fill="$vuetify.theme.themes[$theme].basic800" height="30")
          v-col.align-self-center
            p.mb-0.h6.basic800--text(v-if="coupon") {{ $t('edit') }} {{ $t('coupon') }}
            p.mb-0.h6.basic800--text(v-else) {{ $t('add') }} {{ $t('coupon') }}

      v-card-text.pa-0
        v-container.pa-0
          v-form(ref="form")
            v-card.pa-4(style="overflow-x: hidden; box-shadow:none")
              .coupon-name(v-if="!coupon")
                div.mt-2.label.basic600--text.text-uppercase {{$t('coupon_code.label')}}
                .c1.basic600--text {{$t('coupon_code.label_detail')}}
                v-text-field.mt-2(v-model='form.code' :placeholder="$t('coupon_code.placeholder')" dense outlined height="40" background-color="basic200" :rules="rules.not_empty" counter :maxlength="50")

              div.mt-2.label.basic600--text.text-uppercase {{ $t('coupon_type.label') }}
              v-radio-group.mt-2(v-model='discountType' row dense)
                v-radio.mb-3(label='By percentage', value='percentage' style="width:100%")
                  template(v-slot:label)
                    div.p1.textColorDefault--text {{ $t('coupon_type.by_percentage') }}
                v-radio.mb-3(label='By amount', value='amount' style="width:100%")
                  template(v-slot:label)
                    div.p1.textColorDefault--text {{ $t('coupon_type.by_amount') }}
                v-radio.mb-3(label='Free shipping', value='shipping' style="width:100%")
                  template(v-slot:label)
                    div.p1.textColorDefault--text {{ $t('coupon_type.free_shipping') }}

              template(v-if="discountType == 'amount'")
                div.label.basic600--text.text-uppercase(v-if="discountType == 'amount'") {{$t('price.label')}}
                v-text-field.mt-2(v-if="discountType == 'amount'" v-model='discount.amount' :placeholder="$t('price.placeholder')" dense outlined height="40" background-color="basic200" type="number" :rules="rules.has_quantity" :prefix="$currency.symbol")
              template(v-if="discountType == 'percentage'")
                div.label.basic600--text.text-uppercase(v-if="discountType == 'percentage'" ) {{$t('percentage.label')}}
                v-text-field.mt-2(v-if="discountType == 'percentage'" v-model='form.discount_percentage' :placeholder="$t('percentage.placeholder')" dense outlined height="40" background-color="basic200" :rules="rules.tax_rate" type="number" suffix="%" min=0 max=100)

              v-row.my-n3
                v-col
                  .payment-due
                    .label.basic600--text.text-uppercase {{ $t('valid_from') }}
                    v-dialog(v-model='validFrom.data.show' width='290px')
                      v-date-picker(v-model='validFrom.date' color="primary" no-title @change="saveDateValidFrom()")
                    v-select.mt-2(v-model="validFrom.date" background-color="basic200" outlined dense hide-no-data :items="fromDateChoices" item-text="name" item-value="id")
                      template(v-slot:append)
                        eva-icon(name="chevron-down-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
                v-col(v-if="validFrom.date" cols="5")
                  .label.basic600--text.text-uppercase {{ $t('field_hour.label') }}
                  v-text-field.mt-2(v-model="validFrom.time" :placeholder="$t('field_hour.placeholder')" background-color="basic200" height="40" outlined dense type="time" :rules="validFrom.date != null? rules.not_empty : []")

              v-row.my-n3.mt-n6
                v-col
                  .payment-due
                    .label.basic600--text.text-uppercase {{ $t('valid_until') }}
                    v-dialog(v-model='validUntil.data.show' width='290px')
                      v-date-picker(v-model='validUntil.date' color="primary" no-title @change="saveDateValidUntil()")
                    v-select.mt-2(v-model="validUntil.date" background-color="basic200" outlined dense hide-no-data :items="untillDateChoices" item-text="name" item-value="id")
                      template(v-slot:append)
                        eva-icon(name="chevron-down-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
                v-col(v-if="validUntil.date" cols="5")
                  .label.basic600--text.text-uppercase {{ $t('field_hour.label') }}
                  v-text-field.mt-2(v-model="validUntil.time" :placeholder="$t('field_hour.placeholder')" background-color="basic200" height="40" outlined dense type="time" :rules="validUntil.date != null? rules.not_empty : []")

              div.label.basic600--text.text-uppercase {{$t('min_amount.label')}}
              v-text-field.mt-2(v-model='discount.min_amount' :placeholder="$t('min_amount.placeholder')" dense outlined height="40" background-color="basic200" type="number" :rules="rules.number_not_empty" :prefix="$currency.symbol")

              y-checkbox.my-auto.mx-0.pa-0(v-model="form.inventory_enabled" hide-details)
                template(v-slot:label)
                  div.p1.my-auto {{ $t('this_coupon_limited_redemption') }}
              div.mt-4(v-if="form.inventory_enabled")
                p.mb-1.label.basic600--text.text-uppercase {{ $t('quantity_remaining') }}*
                v-text-field.my-2(v-model="form.inventory_qty" background-color="basic200" height="40" outlined dense placeholder="0" type="number" :rules="rules.has_quantity")

      v-card-actions.pa-2.pb-4
        v-spacer
        v-btn(text @click='showModal = false' depressed height=32 )
          .button-Aa-small.primary400--text| {{ $t('cancel') }}
        v-btn.mr-2(color='textColorAccent' depressed height=32 @click="clickSave" :loading="isLoading")
          .button-AA-small.basic100--text| {{ $t('save') }}

</template>

<script>
import { mapActions } from 'vuex'
import { DateTime } from 'luxon'
import IntelAvatar from '@/components/IntelAvatar.vue'
export default {
  name: 'AddCouponDialog',
  props: ['open', 'parentCoupon', 'company'],
  components: { IntelAvatar },
  data: (v) => ({
    form: v.parentCoupon || {
      id: null,
      company: null,
      code: null,
      discount_percentage: null,
      discount_amount: null,
      free_shipping: false,
      minimum_order_amount: 0,
      inventory_qty: 0,
      inventory_enabled: false,
      valid_from: null,
      valid_until: null,
    },
    originalFromDateChoices: [],
    fromDateChoices: [],
    validFrom: {
      date: null,
      time: null,
      data: {
        show: false,
        value: null
      }
    },
    originalUntillDateChoices: [],
    untillDateChoices: [],
    validUntil: {
      date: null,
      time: null,
      data: {
        show: false,
        value: null
      }
    },
    hasLimitedRedemption: false,
    discountType: 'percentage',
    discount: {
      amount: null,
      min_amount: null,
    },
    isLoading: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      number_not_empty: [v => v !== null || 'This field is required'],
      is_selected: [(v) => v !== null || 'This field is required'],
      has_quantity: [(v) => !!v || 'This field is required', (v) => v != 0|| 'This field is required'],
      has_items: [(v) => !!v || 'This field is required'],
      tax_rate: [
        v => !!v || 'This field is required',
        v => v >= 1 || 'Discount should not be below 1%',
        v => v <= 100 || 'Discount should not be above 100%',
      ]
    },
  }),
  computed: {
    coupon: {
      get() {
        return this.parentCoupon
      },
      set(newValue) {
        this.$emit('update:parentCoupon', newValue)
      }
    },
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  watch: {
    'validFrom.date' (val) {
      if (val === 'custom') {
        this.validFrom.data.show = true
        this.validFrom.date = (this.coupon && this.coupon.valid_from) ? DateTime.fromISO(this.coupon.valid_from).toFormat('yyyy-MM-dd') : DateTime.local().toFormat('yyyy-MM-dd')
      }
      if (val) {
        this.fromDateChoices = [ ...this.originalFromDateChoices ]
        this.fromDateChoices.push({ name: this.formatDate(this.validFrom.date), id: this.validFrom.date})
      } else {
        this.fromDateChoices = [ ...this.originalFromDateChoices ]
      }
    },
    'validUntil.date' (val) {
      if (val === 'custom') {
        this.validUntil.data.show = true
        this.validUntil.date = (this.coupon && this.coupon.valid_until) ? DateTime.fromISO(this.coupon.valid_until).toFormat('yyyy-MM-dd') : DateTime.local().toFormat('yyyy-MM-dd')
      }
      if (val) {
        this.untillDateChoices = [ ...this.originalUntillDateChoices ]
        this.untillDateChoices.push({ name: this.formatDate(this.validUntil.date), id: this.validUntil.date})
      } else {
        this.untillDateChoices = [ ...this.originalUntillDateChoices ]
      }
    }
  },
  mounted () {
    let today = DateTime.local()
    let selectedFromDate = DateTime.local()
    let selectedUntilDate = DateTime.local()
    if (this.coupon) {
      if (this.coupon.discount_percentage) {
        this.discountType = 'percentage'
      } else if (this.coupon.discount_amount) {
        this.discountType = 'amount'
        this.discount.amount = this.coupon.discount_amount / this.$currency.multiplier
      } else if (this.coupon.free_shipping) {
        this.discountType = 'shipping'
      }
      if (this.coupon.minimum_order_amount) {
        this.discount.min_amount = this.coupon.minimum_order_amount / this.$currency.multiplier
      } else {
        this.discount.min_amount = 0
      }
      if (this.coupon.valid_from) {
        const validFrom = DateTime.fromISO(this.coupon.valid_from)
        this.validFrom.date = validFrom.toFormat('yyyy-MM-dd')
        this.validFrom.time = validFrom.toFormat('HH:mm')
        selectedFromDate = validFrom
      }
      if (this.coupon.valid_until) {
        const validUntil = DateTime.fromISO(this.coupon.valid_until)
        this.validUntil.date = validUntil.toFormat('yyyy-MM-dd')
        this.validUntil.time = validUntil.toFormat('HH:mm')
        selectedUntilDate = validUntil
      }
    }

    this.originalFromDateChoices = [
      { name: this.$t('now'), id: null },
      { name: `${this.$t('from')} ${selectedFromDate.toFormat('dd/MM/yyyy')}`, id: selectedFromDate.toFormat('yyyy-MM-dd') },
      { name: this.$t('after_num_days', { num: 15 }), id: today.plus({ days: 15 }).toFormat('yyyy-MM-dd') },
      { name: this.$t('after_num_days', { num: 30 }), id: today.plus({ days: 30 }).toFormat('yyyy-MM-dd') },
      { name: this.$t('after_num_days', { num: 45 }), id: today.plus({ days: 45 }).toFormat('yyyy-MM-dd') },
      { name: this.$t('after_num_days', { num: 60 }), id: today.plus({ days: 60 }).toFormat('yyyy-MM-dd') },
      { name: this.$t('after_num_days', { num: 90 }), id: today.plus({ days: 90 }).toFormat('yyyy-MM-dd') },
      { name: this.$t('custom'), id: 'custom'}
    ]
    this.fromDateChoices = [ ...this.originalFromDateChoices ]

    this.originalUntillDateChoices = [
      { name: this.$t('no_limit'), id: null },
      { name: `${this.$t('until')} ${selectedUntilDate.toFormat('dd/MM/yyyy')}`, id: selectedUntilDate.toFormat('yyyy-MM-dd') },
      { name: this.$t('within_num_days', { num: 15 }), id: today.plus({ days: 15 }).toFormat('yyyy-MM-dd') },
      { name: this.$t('within_num_days', { num: 30 }), id: today.plus({ days: 30 }).toFormat('yyyy-MM-dd') },
      { name: this.$t('within_num_days', { num: 45 }), id: today.plus({ days: 45 }).toFormat('yyyy-MM-dd') },
      { name: this.$t('within_num_days', { num: 60 }), id: today.plus({ days: 60 }).toFormat('yyyy-MM-dd') },
      { name: this.$t('within_num_days', { num: 90 }), id: today.plus({ days: 90 }).toFormat('yyyy-MM-dd') },
      { name: this.$t('custom'), id: 'custom'}
    ]
    this.untillDateChoices = [ ...this.originalUntillDateChoices ]
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    saveDateValidFrom () {
      this.validFrom.data.show = false
      this.validFrom.data.value = this.formatDate(this.validFrom.date)
    },
    saveDateValidUntil () {
      this.validUntil.data.show = false
      this.validUntil.data.value = this.formatDate(this.validUntil.date)
    },
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      this.form.discount_percentage = this.discountType == 'percentage' ? this.form.discount_percentage : 0
      this.form.discount_amount = this.discountType == 'amount' ? (parseFloat(this.discount.amount)).toFixed(this.$currency.exponent).replace('.', '') : 0
      this.form.free_shipping = this.discountType == 'shipping' ? true : false
      this.form.minimum_order_amount = (parseFloat(this.discount.min_amount)).toFixed(this.$currency.exponent).replace('.', '')
      this.form.valid_from = this.validFrom.date ? DateTime.fromFormat(`${this.validFrom.date} ${this.validFrom.time}`, 'yyyy-MM-dd HH:mm') : null
      this.form.valid_until = this.validUntil.date ? DateTime.fromFormat(`${this.validUntil.date} ${this.validUntil.time}`, 'yyyy-MM-dd HH:mm') : null
      this.form.company = this.company.id
      if (this.form.id) {
        this.axios.patch(`/promo/coupons/${this.form.id}/`, this.form)
          .then(resp => {
            this.showModal = false
            this.showMessage(['success', this.$t('success_message.coupon_edited')])
            this.$emit('update:coupon', resp.data)
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.isLoading = false
          })
          return
      }
      this.axios.post(`/promo/coupons/`, this.form)
        .then(resp => {
          this.showModal = false
          this.showMessage(['success', this.$t('success_message.coupon_added')])
          this.$emit('added', resp.data)
        })
        .catch(e => {
          if (e.response && e.response.data && e.response.data.non_field_errors && e.response.data.non_field_errors.length > 0) {
            this.showMessage(['error', e.response.data.non_field_errors[0]])
          } else {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "details": "Details",
    "coupon_code": {
      "label": "Coupon code",
      "label_detail": "You cannot change this code later after you add",
      "placeholder": "Write coupon code here"
    },
    "coupon_type": {
      "label": "Coupon Type",
      "by_percentage": "By percentage",
      "by_amount": "By amount",
      "free_shipping": "Free shipping"
    },
    "price": {
      "label": "Discount",
      "placeholder": "0"
    },
    "percentage": {
      "label": "Discount",
      "placeholder": "1 - 100"
    },
    "min_amount": {
      "label": "Minimum order amount",
      "placeholder": "0"
    },
    "valid_from": "Valid from",
    "valid_until": "Valid until",
    "this_coupon_limited_redemption": "This coupon has limited redemption",
    "quantity_remaining": "Quantity Remaining",
    "field_hour": {
      "label": "Hour",
      "placeholder": "Set hour"
    }
  },
  "id": {
    "details": "Rincian",
    "coupon_code": {
      "label": "Kode Kupon",
      "label_detail": "Anda tidak dapat mengubah kode ini nanti setelah kamu menambahkan",
      "placeholder": "Tulis kode kupon di sini"
    },
    "coupon_type": {
      "label": "Jenis Kupon",
      "by_percentage": "Berdasarkan Persentase",
      "by_amount": "Berdasarkan Jumlah",
      "free_shipping": "Pengiriman gratis"
    },
    "price": {
      "label": "Diskon",
      "placeholder": "0"
    },
    "percentage": {
      "label": "Diskon",
      "placeholder": "1 - 100"
    },
    "min_amount": {
      "label": "Jumlah Pemesanan Minimum",
      "placeholder": "0"
    },
    "valid_from": "Berlaku Dari",
    "valid_until": "Berlaku Hingga",
    "this_coupon_limited_redemption": "Kupon ini memiliki penukaran terbatas",
    "quantity_remaining": "Quantity Remaining"
  }
}
</i18n>